import * as React from 'react';
import { observer } from 'mobx-react';
import BackButton from 'components/BackButton';
import Separator from 'components/Separator';
import SectionTitle from 'components/SectionTitle';
import SectionItem from 'components/Forms/SectionItem';
import Section from 'components/Forms/Section';
import Input from 'components/Forms/Input';
import ActionButton from 'components/ActionButton';
import { FormState, FieldState } from 'formstate';
import { required } from 'helpers/FormValidation';
import Form from 'components/Forms/Form';
import Moment from 'moment';
import { conversationStore } from 'stores/ConversationStore';

interface MessageItemProps {
    name: string,
    date: string,
    message: string
}

const MessageItem = (props: MessageItemProps) => (
    <SectionItem
        title={
            <div>
                <p>{props.name}</p>
                <p className='text-xs'>{Moment(props.date).local().format('MM-DD-YYYY hh:mm A')}</p>
            </div>
        }
        hideSeparator={true} >
        <Input readOnlyValue={props.message} />
    </SectionItem>
)

@observer class ConversationPage extends React.Component<any> {

    form = new FormState({
        message: new FieldState('').validators(required)
    })

    onSendMessage = () => {
        const message = this.form.$.message.$;
        conversationStore.sendMessage(message);
    }

    getActivityIdFromParams() {
        return this.props.match.params.activityId;
    }

    componentDidMount() {
        conversationStore.getConversation(this.getActivityIdFromParams(), true);
    }

    componentWillUnmount() {
        conversationStore.resetStore();
    }

    render() {
        const messages = conversationStore.messages || [];

        return (
            <div className='w-full'>
                <div className='flex'>
                    <div>
                        <BackButton />
                    </div>
                </div>

                <Separator />

                <div className='mt-10'>
                    <Section className='mb-10'>
                        <Form onValidSubmit={this.onSendMessage} formState={this.form}>
                            <SectionItem title='You' hideSeparator={true}>
                                <div className='pt-3'>
                                    <Input
                                        fieldState={this.form.$.message}
                                        textArea={true}
                                        placeholder='Write your message...'
                                    />
                                </div>
                                <div className='text-right mt-2'>
                                    <ActionButton
                                        primary={true}
                                        text='Send'
                                        width='narrow'
                                    />
                                </div>

                            </SectionItem>
                        </Form>
                    </Section>

                    {
                        messages.length > 0 &&
                        <SectionTitle title='Messages' />
                    }

                    <Section>
                        {
                            messages.map((message, index) => (
                                <MessageItem
                                    key={index}
                                    date={message.get('createdAt')}
                                    name={message.get('sender').get('name')}
                                    message={message.get('message')}
                                />
                            ))
                        }
                    </Section>
                </div>

            </div>
        )
    }
}

export default ConversationPage;